import { ChangeEvent } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { SearchInput } from '@destination/components';

export default function SearchModelModule() {
  const [searchParams, setSearchParams] = useSearchParams();

  const { t } = useTranslation(undefined, { keyPrefix: 'browse' });

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    const params = new URLSearchParams(window.location.search);

    if (inputValue === '') {
      params.delete('module');
      return setSearchParams(params);
    }

    params.set('module', event.target.value);
    setSearchParams(params);
  };

  return (
    <SearchInput
      placeholder={t('search_module.placeholder')}
      onChange={handleChange}
      value={searchParams.get('module') || ''}
    />
  );
}
